import { useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component';
import { useAwards } from "./../../../../commons/customHooks/Award"
import HallOfFame from './../../../../commons/components/Award/HallOfFame'

type props = {}

const HallOfFameComponent = (({}:props) => {
  const [ request_params, setParams ] = useState({
    page: 1,
    limit: 10,
    type: 'ended'
  })
  const [ awards, params ] = useAwards(request_params)

  const fetchMoreData = () => {
    setParams(p => ({
      ...p,
      page: p.page + 1
    }))
  }

  return (
    <div id="ranking-page-hall-of-fame">
      <InfiniteScroll
        dataLength={awards.length}
        next={fetchMoreData}
        hasMore={params.current_page < params.last_page}
        loader={null}
      >
        <div className="main-hall-of-fame">
          {awards.map((award, key) => (
            <HallOfFame award={award} key={key} />
          ))}
        </div>
      </InfiniteScroll>
    </div>
  )
})

export default HallOfFameComponent;
